import tw, { styled } from 'twin.macro';

export const Container = styled.section`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`px-2 lg:px-0`}
  ${tw`grid grid-cols-12`}
`;

export const Wrapper = styled.div<{
  columns: Queries.kontent_item_single_media_elements_width_enum;
  hasBackground: boolean;
}>`
  ${tw`rounded-md md:rounded-lg lg:rounded-2xl overflow-hidden`}
  ${({ columns }) => {
    switch (columns) {
      case 'columns_10':
        return tw`col-span-12 lg:col-start-2 lg:col-end-12`;
      case 'columns_12':
        return tw`col-span-12`;
    }
  }}
  ${({ hasBackground }) =>
    hasBackground && tw`p-1 md:p-2 lg:p-3 bg-gradient-to-b from-[#EEF4FC] to-[#B7D3F2]`}

  & iframe,
  & > picture {
    ${tw`rounded lg:rounded-lg`}
  }
`;
